<script lang="ts">
import MobilePaymentForm from "@/components/forms/payout/forms/mobile/MobilePaymentForm.vue";
import {
  UkrainianMobilePaymentModel,
} from "@/components/forms/payout/forms/mobile/mobile-payment";
import Vue from "vue";

export default class UkrainianMobilePaymentForm extends MobilePaymentForm {
  model = Vue.observable(new UkrainianMobilePaymentModel())
}
</script>

<style scoped>

</style>

<i18n>
{
  "ru": {
    "account_hint": "Номер телефона. Пример: 380661234567"
  },
  "en": {
    "account_hint": "Phone number. Example: 380661234567"
  }
}
</i18n>
